export const CREATE_OFFER = `SellerCreateOffer/CREATE_OFFER`
export const OFFER_CREATED = `SellerCreateOffer/OFFER_CREATED`
export const SET_DEFAULT_OFFER_VALUE = `SellerCreateOffer/SET_DEFAULT_OFFER_VALUE`
export const OFFER_VALUE_CHANGED = `SellerCreateOffer/OFFER_VALUE_CHANGED`
export const CALENDAR_DATE_SELECTED = `SellerCreateOffer/CALENDAR_DATE_SELECTED`
export const START_TIME_SELECTED = `SellerCreateOffer/START_TIME_SELECTED`
export const START_TIME_IS_OVERLAPPING = `SellerCreateOffer/START_TIME_IS_OVERLAPPING`
